import { PropertyFilterProcessingNode } from './PropertyFilterProcessingNode';
/**
 * @category Processing node
 */
export class SMAFilterNode extends PropertyFilterProcessingNode {
  constructor(propertySelector, propertyModifier, options) {
    super(propertySelector, propertyModifier, options);
  }
  initFilter(object, value, options) {
    return new Promise(resolve => {
      if (options.taps < 1) {
        throw new Error(`Filter taps needs to be higher than 1!`);
      }
      resolve({
        x: [],
        taps: options.taps
      });
    });
  }
  filter(object, value, filter, options) {
    return new Promise(resolve => {
      filter.x.push(value);
      if (filter.x.length > filter.taps) {
        filter.x.shift();
      } else if (options.minTaps && filter.x.length < options.minTaps) {
        resolve(value);
      }
      if (typeof value === 'number') {
        const sum = filter.x.reduce((a, b) => a + b);
        resolve(sum / filter.taps);
      } else {
        const sum = filter.x[0].clone();
        for (let i = 1; i < filter.x.length; i++) {
          sum.add(filter.x[i]);
        }
        resolve(sum.divideScalar(filter.taps));
      }
    });
  }
}